import { Trans, useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { cancelExclusionDraw, setPlaneDrawActive } from '../../../../store/reducers/measurementPlanes.reducer.ts';

/** Floating hint shown (top-centre, below the header) while drawing a calculation area
 *  or cutting an exclusion hole. Area settings live in the sidebar section. */
export function MeasurementPlanePanel(): JSX.Element | null {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const drawActive = useAppSelector((s) => s.measurementPlanes.draw.active);
  const vertCount = useAppSelector((s) => s.measurementPlanes.draw.verts.length);
  const exclusion = useAppSelector((s) => s.measurementPlanes.exclusionDraw);

  // top-[72px] clears the 64px app header (Navbar) so the hint isn't hidden behind it.
  const wrap = 'fixed top-[72px] left-1/2 -translate-x-1/2 w-[360px] max-w-[90vw] rounded-xl p-3 shadow-2xl z-50';

  if (exclusion.active) {
    const n = exclusion.verts.length;
    return (
      <div className={`${wrap} bg-[#1E1E1E] border border-red-400/30`}>
        <div className="text-sm text-red-400 font-medium mb-1">{t('workspace.panel.surfaces.cuttingTitle')}</div>
        <div className="text-xs text-white/70 leading-relaxed">
          <Trans
            i18nKey="workspace.panel.surfaces.cuttingFloating"
            values={{ count: n }}
            components={[<span key="0" className="text-white" />, <span key="1" className="text-white" />]}
          />
        </div>
        <button
          onClick={() => dispatch(cancelExclusionDraw())}
          className="mt-2 w-full text-xs text-gray-400 hover:text-white underline"
        >
          {t('common.cancel')}
        </button>
      </div>
    );
  }

  if (!drawActive) return null;

  return (
    <div className={`${wrap} bg-[#1E1E1E] border border-white/10`}>
      <div className="text-sm text-[#d4ff33] font-medium mb-1">{t('workspace.panel.surfaces.drawingTitle')}</div>
      <div className="text-xs text-white/70 leading-relaxed">
        <Trans
          i18nKey="workspace.panel.surfaces.drawingFloating"
          values={{ count: vertCount }}
          components={[<span key="0" className="text-white" />, <span key="1" className="text-white" />]}
        />
      </div>
      <button
        onClick={() => dispatch(setPlaneDrawActive(false))}
        className="mt-2 w-full text-xs text-gray-400 hover:text-white underline"
      >
        {t('workspace.panel.surfaces.cancelDrawing')}
      </button>
    </div>
  );
}
